import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { LocumsUtility } from 'src/app/locums/locums-utility';
import { UnitDetails } from 'src/app/locums/models/unit-details.model';
import { selectJobUnitDetails } from 'src/app/root-store/locums-store/selectors/job.selector';

@UntilDestroy()
@Component({
    selector: 'nova-locums-recruiter-experience',
    templateUrl: './locums-recruiter-experience.component.html',
    styleUrls: ['./locums-recruiter-experience.component.scss']
})
export class LocumsRecruiterExperienceComponent implements OnInit {
    @Input() jobId: number;

    jobUnitDetails$: Observable<UnitDetails>;
    showUDExperience = false;
    locumsUtility = LocumsUtility;

    constructor(private readonly store: Store) {}

    ngOnInit(): void {
        this.jobUnitDetails$ = this.store.select(selectJobUnitDetails);
        this.jobUnitDetails$
            .pipe(untilDestroyed(this))
            .subscribe((x) => (this.showUDExperience = LocumsUtility.shouldShowExperience(x)));
    }
}
